<div class="dvb-timeline-entry-icon">
    <div class="timeline-icon"
         ng-bind-html="vm.iconHTML"
         uib-tooltip="{{vm.iconTooltipText}}"
         tooltip-placement="top">
    </div>
    <div class="line"></div>
</div>
